import { isNil } from '@ping/utils';
import { selectedMarketInstrumentSelector, useMarketStore } from '@ping/stores/market.store';

import { useMarketPair, usePortfolio } from '../helpers';
import { OrderFormStructure } from '../OrderFormStructure';
import { useMarketBuyFormState } from './market-buy-form-state.hook';

import type { IMarketDataType } from '@ping/websockets';

const ZERO = 0 as const;

interface IMarketOrderBuyFormProps {
  market: IMarketDataType;
  isDisabled?: boolean;
  isMarketFixedRatio?: boolean;
}

export const MarketOrderBuyForm = (props: IMarketOrderBuyFormProps) => {
  const instrument = useMarketStore(selectedMarketInstrumentSelector);
  const pair = useMarketPair(instrument);
  const { portfolio, isPortfolioFetched } = usePortfolio();
  const balance = isPortfolioFetched ? portfolio.get(pair.quoteAsset)?.availableAmount : ZERO;

  const buyState = useMarketBuyFormState({
    pair,
    balance,
    marketClosePrice: props.market?.close ?? ZERO,
  });

  return (
    <OrderFormStructure
      orderKind='market'
      orderSide='buy'
      instrument={instrument}
      state={buyState}
      isDisabled={props.isDisabled || isNil(balance) || balance === ZERO}
      isMarketFixedRatio={props.isMarketFixedRatio}
    />
  );
};
